import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { GET } from "../../config/httpMain";
import UserManagerApiUrl from "../userManager/userManagerAPIURL";
import { logout, UpdateLoginUserData } from "../../auth/userSlice";

const SsoPage = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const calledRef = useRef(false);          // blocks the double call in React StrictMode
    const [error, setError] = useState(false);

    const sessionRemove = () => {
        dispatch(logout())
        sessionStorage.removeItem("user");
    }
    useEffect(() => {
        if (calledRef.current) return;
        calledRef.current = true;

        const code = new URLSearchParams(window.location.search).get("code");

        // remove the code from the address bar immediately
        window.history.replaceState({}, "", "/sso");

        if (!code) {
            sessionRemove();
            navigate("/login", { replace: true });
            return;
        }

        GET(`${UserManagerApiUrl.ExchangeCode}?code=${code}`).then((response: any) => {
            if (response?.data?.isSuccess) {
                const objUser = response.data.result;
                sessionStorage.setItem("user", JSON.stringify(objUser));
                dispatch(UpdateLoginUserData(objUser));
                navigate("/dashboard", { replace: true });
            } else {
                setError(true);
                toast.warning("Session link expired. Please login again.");
                sessionRemove();
                setTimeout(() => navigate("/login", { replace: true }), 1500);
            }
        })
            .catch((e: any) => {
                console.error(e?.message);
                setError(true);
                toast.error("Something went wrong");
                sessionRemove();
                setTimeout(() => navigate("/login", { replace: true }), 1500);
            });
    }, []);

    return (
        <div style={{ display: "flex", height: "100vh", alignItems: "center", justifyContent: "center" }}>
            {error ? "Redirecting to login..." : "Switching company, please wait..."}
        </div>
    );
};

export default SsoPage;